module.exports = __webpack_public_path__ + "img/media4.b85d5d72.png";